<template>
    <div>
    <el-dialog
            title="我的签到记录"
            :close-on-click-modal="false"
            :visible="editData.state"
            append-to-body
            width="780px"
            @close="closeModal()"
    >
        <div>
            <el-form :model="formValidate" ref="ruleForm" label-width="80px" class="demo-ruleForm">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="上课地点">
                            <el-input v-model="formValidate.classrooms" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="课程名称">
                            <el-input v-model="formValidate.courseName" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="上课日期">
                            <el-input v-model="formValidate.date" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="上课时间">
                            <el-input v-model="formValidate.classTime" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="课程节数">
                            <el-input v-model="formValidate.knob" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="签到位置">
                            <el-input v-model="formValidate.weizhi" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="签到类型">
                            <el-input v-model="formValidate.statusName" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="签到方式">
                            <el-input v-model="formValidate.typeName" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="签到时间">
                            <el-input v-model="formValidate.attendanceTime" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <el-input v-model="formValidate.remark" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
             <el-button type="primary" @click="submitForm">补 签</el-button>
        </span>
    </el-dialog>
    <el-dialog
            title="补签"
            :visible.sync="dialogVisible"
            append-to-body
            :close="closeR"
            width="30%">
        <el-input v-model="remark"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeR">关闭</el-button>
                <el-button type="primary" @click="submit">提 交</el-button>
          </span>
    </el-dialog>
    </div>
</template>

<script>
    import {getRecordInfo, setToSinIn} from "@/api/overseasChinese/overseasChinese"
    export default {
        props: {
            editData: {
                type: Object,
                required: true
            }
        },
        components: {},
        data() {
            return {
                dataInfo:{},
                formValidate: {
                    classrooms: '',
                    courseName: '',
                    date: '',
                    classTime: '',
                    knob: '',
                    weizhi: '',
                    statusName: '',
                    typeName: '',
                    attendanceTime: '',
                    remark: ''
                }, // 表单数据绑定
                dialogVisible: false,
                remark:'',
            };
        },
        watch: {
            "editData.state": {
                //深度监听，可监听到对象、数组的变化
                handler(val, oldVal) {
                    let arr = this.editData.data.timeRange.split('-')
                    this.editData.data.startTime =  this.editData.data.date + ' ' + arr[0]
                    this.editData.data.endTime =  this.editData.data.date + ' ' + arr[1]
                    this.getEditData()
                },
                deep: true
            }
        },
        computed: {},
        methods: {
            getEditData(){
                let data= this.editData.data
                let params = {
                    day: data.day || '',
                    pkteachclassid: data.pkteachclassid || '',
                    semesterId: data.termid || '',
                    timeType: data.timeType || '',
                    week: data.week || ''
                }
                getRecordInfo(params).then((res) =>{
                    if(res.data.code == '0'){
                        let data = res.data.data
                        this.dataInfo = res.data.data
                        this.formValidate = Object.assign(this.formValidate, data);
                        this.formValidate.weizhi = data.status == 4 ? '无' : data.classrooms
                        this.formValidate.statusName = data.status == 1 ? '正常' :  data.status == 2 ? '迟到' :  data.status == 3 ? '早退' : '缺勤'
                        this.formValidate.typeName = data.type == '1' ? '手工' : '扫码'
                    }else {
                        this.$message.warning(res.data.msg||'获取信息失败!')
                    }
                })
            },
            closeModal() {
                this.$emit("closeEdit", {state: false});
                this.editData.state = false;
            },
            submitForm() {
                this.dialogVisible = true
            },
            submit(){
                let editData= this.editData.data
                let params = {
                    status: '5',
                    classroomId:this.dataInfo.classroomId || '',
                    classrooms:this.dataInfo.classrooms || '',
                    courseId:this.dataInfo.courseid || '',
                    courseName:this.dataInfo.courseName || '',
                    date:this.dataInfo.date || '',
                    day:editData.day || '',
                    endTime:editData.endTime || '',
                    startTime:editData.startTime || '',
                    knob:editData.knob || '',
                    pkteachclassid:editData.pkteachclassid || '',
                    remark:this.remark || '',
                    termid:editData.termid|| '',
                    timeType:editData.timeType|| '',
                    type:this.dataInfo.type|| '',
                    week:editData.week|| '',
                }
                setToSinIn(params).then((res) =>{
                    if(res.data.code == '0'){;
                        this.$message.success('补签成功!')
                        this.dialogVisible = false
                        this.getEditData()
                    }else {
                        this.$message.warning(res.data.msg||'补签失败!')
                    }
                })
            },
            closeR(){
                this.dialogVisible = false
                for (let item of Object.keys(this.formValidate)) {
                    this.formValidate[item] = "";
                }
            }
        }
    }
</script>

<style scoped>

</style>